import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from './i18n';

const LangCtx = createContext({ lang: 'en', setLang: () => {}, t: translations.en });

export const LanguageProvider = ({ children }) => {
  // Always default to English on first load. Once the user explicitly picks
  // a language, we persist it for the rest of the session.
  const [lang, setLang] = useState('en');
  const setLangPersist = (l) => {
    setLang(l);
    try { localStorage.setItem('da_lang', l); } catch (e) { /* ignore */ }
  };

  // After mount, if the user is logged in, restore their preferred language.
  useEffect(() => {
    try {
      const token = localStorage.getItem('da_token');
      const stored = localStorage.getItem('da_lang');
      if (token && stored && ['en', 'fr', 'es'].includes(stored)) {
        setLang(stored);
      }
    } catch (e) { /* ignore */ }
  }, []);

  return (
    <LangCtx.Provider value={{ lang, setLang: setLangPersist, t: translations[lang] || translations.en }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
